/**
 * Stable CMOE competition id for a room session (no scan required).
 * @param {string} roomCode
 */
export function competitionIdForRoomCode(roomCode) {
  const code = String(roomCode || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, "_");
  return `rs_${code || "unknown"}`;
}
